import { observer } from 'mobx-react-lite'
import { useRef } from 'react'
import { uiStore } from 'shared/store/uiStore'
import { makeTextFieldLoading, TextField } from 'shared/ui/TextField'
import { useCallHistoryContext } from 'pages/conversations/pages/calls/ui/CallHistory/context/callHistoryContext'
import styles from '../styles.module.scss'

export const CallHistorySearch = observer(() => {
  const { startFocusingMode, endFocusingMode } = uiStore
  const { search, handleSearch, loadingSearch } = useCallHistoryContext()
  const ref = useRef<HTMLInputElement | null>(null)

  return (
    <div className={styles.searchInputWrap}>
      <TextField
        className={styles.textField}
        variant='integrated'
        InputProps={{
          placeholder: 'Search...',
          onFocus: startFocusingMode,
          onBlur: endFocusingMode,
          ref: ref,
        }}
        onChange={handleSearch}
        value={search || ''}
        rightActions={[makeTextFieldLoading({ loading: loadingSearch })]}
      />
    </div>
  )
})
